import React from "react"

import ContentLines from "../../common/content-loading/ContentLines"
import ListItemImageShadow from "../../common/content-loading/ListItemImageShadow"

export default () => (
    <div className="list-group-item">
        <ListItemImageShadow />
        <div className="list-group-item-content">
            <ContentLines minLineLength={30} />
            <ContentLines minLineLength={20} maxLineLength={40} />
            <ContentLines lineLength={20} />
        </div>
    </div>
)
